import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Page } from "src/app/model/Page";
import { ModalController } from "@ionic/angular";
import { BlockchainApplicationListModel } from "src/app/model/BlockchainApplicationListModel";
import { BlockchainApplicationService } from "src/app/services/blockchain-application.service";
import { ViewPdfComponent } from "../view-pdf/view-pdf.component";
import { VerifyBlockchainComponent } from "./verify-blockchain/verify-blockchain.component";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { BlockchainAuditTrailComponent } from "./blockchain-audittrail/blockchain-audittrail.component";

@Component({
  selector: "app-secure-blockchain-verify-list",
  templateUrl: "./blockchain-verify-list.component.html",
  styleUrls: ["./blockchain-verify-list.component.scss"],
})
export class BlockchainVerifyListComponent implements OnInit, AfterViewInit {
  blockchainApplicationList : Page<BlockchainApplicationListModel>;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource: MatTableDataSource<BlockchainApplicationListModel> = new MatTableDataSource();
  displayedColumns: string[] = [
    "id",
    "applicationNo",
    "applicantPhoto",
    "lsct",
    "document",
    "action",    
  ];
  pageSizeOptions: number[] = [10, 25, 100];
  isLoading = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  filterForm: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;
  boardList: {[key: number]: string};
  lotteryList: {[key: number]: string};
  schemeList: {[key: number]: string};

  boardId: number;
  lotteryId: number;
  schemeId: number;
  blockchainTransactionType: string;
  
  filteredListParams: {
    boardId: number,
    lotteryId: number,
    schemeId: number,
    blockchainTransactionType: string,
    filterText: string,
  };

  constructor(
    private blockchainApplicationService: BlockchainApplicationService,
    private _snackBar: MatSnackBar, private modalCtrl: ModalController,
    private route: ActivatedRoute, private router: Router
  ) {}

  ngOnInit(): void {
    
    this.route.params.subscribe((params: Params) => {
      this.boardId = +params['boardId'];
      this.lotteryId = +params['lotteryId'];
      this.schemeId = +params['schemeId'];
      this.blockchainTransactionType = params['blockchainTransactionType'];
    });

    if(this.blockchainTransactionType) {
      console.log('blockchainTransactionTypefsdfsdf', this.blockchainTransactionType);
      this.filterForm.patchValue({
        blockchainTransactionType: {key: this.blockchainTransactionType, value: this.blockchainTransactionType.replace('/_//g', ' ')}
      });
    }
    
    this.isLoading = true;
    this.blockchainApplicationService.initFormFetchBoard().subscribe((data) => {
      this.isLoading = false;
      if(data.status === 'SUCCESS') {
        this.boardList = data.lst;
        if(this.boardId) {
          let selectedBoard = this.boardList[this.boardId];
          if(selectedBoard) {
            this.filterForm.patchValue({
              boardId: {key: this.boardId, value: selectedBoard}
            });
          }

          this.fetchLotteries({key: this.boardId, value: selectedBoard}, true);
        }
        else {
          if(this.blockchainTransactionType) {
            this.onSearch();
          }
        }
      }
      else {
        this.blockchainApplicationService.errorToast(data.errorMessage);
      }
    }, (error) => {
      this.isLoading = false;
      this.blockchainApplicationService.errorToast(error?.errorMessage?.errorMessage);
    });

    this.filterForm = new FormGroup({
      boardId: new FormControl({key: null, value: 'All Boards'}),
      lotteryId: new FormControl({key: null, value: 'All Lotteries'}),
      schemeId: new FormControl({key: null, value: 'All Schemes'}),
      blockchainTransactionType: new FormControl(
        this.blockchainTransactionType 
        ? {key: this.blockchainTransactionType, value: this.blockchainTransactionType.replace('/_//g', ' ')}
        : {key: null, value: 'All Letters'}),
      filterText: new FormControl(null, [Validators.minLength(3)]),
    });
  }

  onSearch() {
    if (this.filterForm.valid) {
      if(this.filterForm.value.boardId?.key || this.filterForm.value.lotteryId?.key || this.filterForm.value.schemeId?.key 
        || this.filterForm.value?.blockchainTransactionType?.key
        || this.filterForm.value?.filterText?.trim()) {
          this.onDataLoad();
      }
      else {
        this._snackBar.open("Please enter criteria for Search", "Close", {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "warning-toast",
          duration: 3 * 1000,
        });
        this.isSearchDisabled = false;
      }
    }
    else {
      this._snackBar.open("Please enter minimum (3 char) for filter", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 3 * 1000,
      });
      this.isSearchDisabled = false;
    }
  }

  resetFilter() {
    this.removeSearchedListAndSavedFilter();
    this.router.navigate(['/secure', 'verify-blockchain'], {replaceUrl: true});
  }

  removeSearchedListAndSavedFilter() {
    this.filteredListParams = null;
    this.filterForm.reset({
      boardId: {key: null, value: 'All Boards'},
      lotteryId: {key: null, value: 'All Lotteries'},
      schemeId: {key: null, value: 'All Schemes'},
      blockchainTransactionType: {key: null, value: 'All Letters'},
      filterText: null
    });
    this.lotteryList = null;
    this.schemeList = null;
    this.blockchainApplicationList = null;
    this.dataSource = null;
    this.paginator.pageIndex = 0;
    this.paginator.length = 0; 
  }
  
  onDataLoad() {
    this.isLoading = true;
    this.isSearchDisabled = true;
    this.filteredListParams = {
      boardId: this.filterForm.value?.boardId?.key,
      lotteryId: this.filterForm.value?.lotteryId?.key,
      schemeId: this.filterForm.value?.schemeId?.key,
      blockchainTransactionType: this.filterForm.value?.blockchainTransactionType.key,
      filterText: this.filterForm.value?.filterText,
    };
  
    this.blockchainApplicationService.fetchBlockchainApplicationList(
      this.currentPage, this.pageSize, this.filteredListParams).subscribe((data) => {
        this.isLoading = false;
        if(data.status === 'SUCCESS') {
          console.log(data);
          this.blockchainApplicationList = data.data;
          this.dataSource = new MatTableDataSource(data.data.content);
          
          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = data.data.totalElements;
          });
    
          this.isSearchDisabled = false;
        }
        else {
          this.blockchainApplicationService.errorToast(data.errorMessage);
        }
      }, (error) => {
        console.log(error);
        this.isLoading = false;
        this.isSearchDisabled = false;
        this.blockchainApplicationService.errorToast(error?.error?.errorMessage||error?.errorMessage);
      }
    );
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  pageChanged(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.onDataLoad();
  }

  downloadFile(base64:string | ArrayBuffer, fileName:string){
    const src = `${base64}`;
    const link = document.createElement("a");
    link.href = src;
    link.download = fileName;
    link.click();
    link.remove();
  }

  viewDocument(blockchainId: number) {
    this.blockchainApplicationService.viewDocument(blockchainId).subscribe(async (data) => {
      if(data.status === 'SUCCESS') {
        const modal = await this.modalCtrl.create({
          component: ViewPdfComponent,
          componentProps: {
            base64: data.data,
            fileName: data.fileName.replace("_", " "),
            documentName: data.fileName.replace("_", " ")
          }
        });
        modal.present();
      }
      else {
        this.blockchainApplicationService.errorToast(data.errorMessage);
      }
    }, (error) => {
      console.log(error);
      this.isLoading = false;
      this.isSearchDisabled = false;
      this.blockchainApplicationService.errorToast(error?.error?.errorMessage||error?.errorMessage);
    });
  }

  verifyFetchDetail(blockchainId: number) {
    this.blockchainApplicationService.verifyFetchDetail(blockchainId).subscribe(async (data) => {
      if(data.status === 'SUCCESS') {
        const modal = await this.modalCtrl.create({
          component: VerifyBlockchainComponent,
          cssClass: 'master-modal',
          componentProps: {
            data
          }
        });
        modal.present();
      }
      else {
        this.blockchainApplicationService.errorToast(data.errorMessage);
      }
    }, (error) => {
      console.log(error);
      this.isLoading = false;
      this.isSearchDisabled = false;
      this.blockchainApplicationService.errorToast(error?.error?.errorMessage||error?.errorMessage);
    });
  }

  showSelectedObject(o1: any, o2: any) {
    if(o1 && o2 && o1.key == o2.key) {
      return o1;
    }
    else {
      return "";
    }
  }

  fetchLotteries(b: {key: number, value: string}, init?: boolean) {
    this.boardId = b.key;
    // this.lotteryId = null;
    // this.schemeId = null;

    this.lotteryList = [];
    this.schemeList = [];

    this.filterForm.patchValue({
      lotteryId: {key: null, value: 'All Lotteries'}
    });

    if(b?.key) {
      this.isLoading = true;
      this.blockchainApplicationService.initFormFetchLottery(b.key).subscribe((data1) => {
        this.isLoading = false;
  
        if(data1.status === 'SUCCESS') {
          this.lotteryList = data1.lst;
          if(this.lotteryId) {
            let selectedLottery = this.lotteryList[this.lotteryId];
            if(selectedLottery) {
              this.filterForm.patchValue({
                lotteryId: {key: this.lotteryId, value: selectedLottery}
              });
            }
  
            this.fetchSchemes({key: this.lotteryId, value: selectedLottery}, init);
          }
          else {
            if(init) {
              this.onSearch();
            }
          }
        }
        else {
          this.blockchainApplicationService.errorToast(data1.errorMessage);
        }
      }, (error) => {
        this.isLoading = false;
        this.blockchainApplicationService.errorToast(error?.errorMessage?.errorMessage);
      });
    }
  }

  fetchSchemes(l: {key: number, value: string}, init?: boolean) {
    this.lotteryId = l.key;
    // this.schemeId = null;
    this.schemeList = [];
    
    this.filterForm.patchValue({
      schemeId: {key: null, value: 'All Schemes'}
    });

    if(l?.key) {
      this.isLoading = true;
      this.blockchainApplicationService.initFormFetchScheme(this.boardId, l.key).subscribe((data2) => {
        this.isLoading = false;
  
        if(data2.status === 'SUCCESS') {
          this.schemeList = data2.lst;
          if(this.schemeId) {
            let selectedScheme = this.schemeList[this.schemeId];
            this.filterForm.patchValue({
              schemeId: {key: this.schemeId, value: selectedScheme}
            });
          }
          if(init) {
            this.onSearch();
          }
        }
        else {
          this.blockchainApplicationService.errorToast(data2.errorMessage);
        }
      }, (error) => {
        this.isLoading = false;
        this.blockchainApplicationService.errorToast(error?.errorMessage?.errorMessage);
      });
    }
  }

  auditTrail(blockchainId: number) {
    this.isLoading = true;
    this.blockchainApplicationService.auditTrail(blockchainId).subscribe(async (data) => {
      this.isLoading = false;
      if(data.status === 'SUCCESS') {
        const modal = await this.modalCtrl.create({
          component: BlockchainAuditTrailComponent,
          cssClass: 'master-modal-lg',
          componentProps: {
            auditTrailList: data.lst
          }
        });
        modal.present();
      }
      else {
        this.blockchainApplicationService.errorToast(data.errorMessage);
      }
    }, (error) => {
      this.isLoading = false;
      this.blockchainApplicationService.errorToast(error?.errorMessage?.errorMessage);
    });
  }

}
